import { takeEvery } from '@redux-saga/core/effects'; // NOSONAR
import { GlobalAction, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { addTaasLoadingActions } from './addTaasLoadingActions.util';
import { addTaasUpdateAppErrorHandling } from './addTaasUpdateAppErrorHandling';

export function* watchBeziehungVpZumVnChanged() {
  yield takeEvery(GlobalActions.ASSEKURANZ_BEZIEHUNG_CHANGED, handleBeziehungVpZumVnChange);
}

export const updateAppActionsGenerator = (): GlobalAction<unknown>[] => {
  return [];
};

export const handleBeziehungVpZumVnChange = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(updateAppActionsGenerator),
);
